export const imageAccommodation = {
  breadcrumbCurrent: "Logo dell'alloggio",
  heading: "Il logo del tuo annuncio",
  subtitle:
    "Carica il logo che identifica questo annuncio. Formati consentiti: PNG, JPG, SVG · max. 5 MB.",
  savedLogoAlt: "Logo salvato",
  activeBadge: "Logo attivo",
  change: "Cambia",
  drop: {
    release: "Rilascialo qui",
    newLogo: "Nuovo logo",
    uploadLogo: "Carica il tuo logo",
    dragOr: "Trascina o",
    clickLink: "clicca",
    formats: "PNG · JPG · SVG · max. 5 MB",
  },
  importButton: "Importa il logo da un altro annuncio",
  crop: {
    removeImage: "Rimuovi immagine",
    tip: "Sposta e regola il ritaglio. Rapporto 2:1 (ideale per loghi orizzontali).",
    saving: "Salvataggio…",
    save: "Salva logo",
  },
  actions: {
    cancel: "Annulla",
  },
  applyModal: {
    title: "Applicare ad altri annunci?",
    subtitle: "Seleziona gli annunci a cui vuoi applicare questo stesso logo.",
    logoAlt: "Logo",
    selectAll: "Seleziona tutti",
    progress: "Applicazione {done}/{total}…",
    skip: "Salta",
    applying: "Applicazione in corso…",
    applyToBtn: "Applica a {count} annuncio | Applica a {count} annunci",
  },
  importModal: {
    title: "Importa logo",
    subtitle: "Scegli il logo di un altro annuncio da utilizzare in questo.",
    loading: "Caricamento annunci…",
    empty: "Nessun annuncio ha ancora un logo.",
    progress: "Importazione del logo…",
    importing: "Importazione in corso…",
  },
  defaultListingName: "Annuncio",
  toasts: {
    invalidFormat: "Formato non valido. Usa PNG, JPG o SVG.",
    fileTooLarge: "Il file supera il limite di {max} MB.",
    selectBeforeSave: "Seleziona e regola un logo prima di salvare.",
    propertyNotFound: "La struttura collegata a questo annuncio non è stata trovata.",
    saveSuccess: "Logo salvato con successo",
    saveError: "Errore durante il salvataggio del logo.",
    listingLoadError: "Impossibile caricare i dettagli dell'annuncio.",
    applySuccess:
      "Logo applicato con successo a {count} annuncio | Logo applicato con successo a {count} annunci",
    applyError:
      "Impossibile applicare a {count} annuncio | Impossibile applicare a {count} annunci",
    listingsLoadError: "Impossibile caricare gli annunci.",
    propertyNotFoundImport: "La struttura per questo annuncio non è stata trovata.",
    importSuccess: 'Logo di "{name}" importato con successo',
    importError: "Errore durante l'importazione del logo.",
  },
};
